module.exports = __webpack_public_path__ + "img/stick.8ed679cc.png";